<template>
  <div class="d-flex px-2">
    <div
      v-for="(tab, index) in tabs"
      :key="index"
      class="tab cursor-pointer"
      :class="{ active: activeTab === tab.value }"
      @click.stop="setActiveTab(tab.value)"
    >
      <slot :name="tab.slotName ?? tab.value" :tab="tab">
        {{ tab.label }}
      </slot>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";

const props = defineProps({
  tabs: {
    type: Array,
    required: true,
  },
  modelValue: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["update:modelValue"]);

const activeTab = ref(props.modelValue);

const setActiveTab = (value) => {
  activeTab.value = value;
  emit("update:modelValue", value);
};

watch(
  () => props.modelValue,
  (value) => {
    activeTab.value = value;
  }
);
</script>

<style scoped lang="scss">
.tab {
  color: $neutral-300;
  padding: 10px;
  font-size: $font-size-sm;

  &.active {
    font-weight: 400;
    border-bottom: 2px solid var(--primary-250);
    color: $neutral-600;
  }
}
</style>
